import { call, put, takeLatest, all } from "redux-saga/effects";
import SDK from "../../config";
import io from "socket.io-client";
import {
    FETCH_WEB_VISITORS_REQUEST,
    fetchWebVisitorsSuccess,
    fetchWebVisitorsFailure,
    FETCH_WEB_MINIWIDGET_REQUEST,
    fetchMiniWidgetDataSuccess,
    fetchMiniWidgetDataFailure,
    FETCH_BETA_SALES_REQUEST,
    fetchBetaSalesSuccess,
    fetchBetaSalesFailure,
    APPLICTION_INSTALATION_REQUEST,
    fetchApplicationInstalationSuccess,
    fetchApplicationInstalationFailure,
    WEB_WEEKLY_INSIGHT_REQUEST,
    fetchWebWeeklyInsightSuccess,
    fetchWebWeeklyInsightFailure,
    ANDROID_USER_ANALYTICS_REQUEST,
    fetchAndroidAnalyticsSuccess,
    fetchAndroidAnalyticsFailure,
    ANDROID_RECENT_ACTIVE_REQUEST,
    fetchRecentActiveSuccess,
    fetchRecentActiveFailure,
    NEW_BETA_JOINER_REQUEST,
    fetchNewBetaJoinerSuccess,
    fetchNewBetaJoinerFailure
} from "./dashboardAction";

const socket = io(SDK.SOCKET_URL);

// API call function for fetching web visitors data
function fetchWebVisitorsApi(days) {
    return new Promise((resolve, reject) => {
        socket.emit("getLatestWebVisitorsData", { days }, (response) => {
            if (Array.isArray(response.androidCount)) {
                const dataWithIndex = response.androidCount.map((item, idx) => ({
                    ...item,
                    index: idx + 1,
                }));
                resolve(dataWithIndex);
            } else {
                reject("Invalid data format received");
            }
        });
    });
}

// Saga Worker for fetching web visitors
function* fetchWebVisitorsSaga(action) {
    const { days } = action.payload;
    try {
        const data = yield call(fetchWebVisitorsApi, days);
        yield put(fetchWebVisitorsSuccess(data));
    } catch (error) {
        yield put(fetchWebVisitorsFailure(error.toString()));
    }
}

// API call function for fetching device counts
function fetchMiniWidgetDataApi() {
    return new Promise((resolve, reject) => {
        socket.emit("getDeviceCounts", (response) => {
            if (response && response.total !== undefined) {
                resolve(response);
            } else {
                reject("Invalid MiniWidget data");
            }
        });
    });
}

// Saga Worker for fetching device counts
function* fetchDeviceCountsSaga() {
    try {
        const data = yield call(fetchMiniWidgetDataApi);
        yield put(fetchMiniWidgetDataSuccess(data));
    } catch (error) {
        yield put(fetchMiniWidgetDataFailure(error.toString()));
    }
}

// API call function for fetching Beta Subscriber counts
function fetchBetaSubscriberApi(days) {
    return new Promise((resolve, reject) => {
        socket.emit("getBetaCounts", { days }, (response) => {
            if (response !== undefined) {
                resolve(response);
            } else {
                reject("Invalid MiniWidget data");
            }
        });
    });
}

// Saga Worker for fetching device counts
function* fetchBetaSubscriberSaga(action) {
    try {
        const { days } = action.payload;

        const data = yield call(fetchBetaSubscriberApi, days);
        yield put(fetchBetaSalesSuccess(data));
    } catch (error) {
        yield put(fetchBetaSalesFailure(error.toString()));
    }
}

// API call function for fetching Device Instalation
function fetchApplicationInstalationApi(days) {
    return new Promise((resolve, reject) => {
        socket.emit("getApplicationDownloader", { days }, (response) => {
            if (response !== undefined) {
                resolve(response);
            } else {
                reject("Invalid MiniWidget data");
            }
        });
    });
}

// Saga Worker for fetching device counts
function* fetchApplicationINstaltionSaga(action) {
    try {
        const { days } = action.payload;

        const data = yield call(fetchApplicationInstalationApi, days);
        yield put(fetchApplicationInstalationSuccess(data));
    } catch (error) {
        yield put(fetchApplicationInstalationFailure(error.toString()));
    }
}

// API call function for fetching Dashboard data
function fetchWebInsInsightDataApi() {
    return new Promise((resolve, reject) => {
        socket.emit("getWebsiteAnalytics", (response) => {
            if (response && response !== null) {
                resolve(response);
            } else {
                reject("Invalid MiniWidget data or response is empty");
            }
        });

    });
}

// Saga function for fetching Dashboard data
function* fetchWebInsightSaga() {
    try {
        const data = yield call(fetchWebInsInsightDataApi);
        yield put(fetchWebWeeklyInsightSuccess(data));
    } catch (error) {
        console.error("Error fetching web insight data:", error);
        yield put(fetchWebWeeklyInsightFailure(error.toString()));
    }
}

// API call function for fetching Android Analytics data
function fetchAndoridAnalyticsDataApi() {
    return new Promise((resolve, reject) => {
        socket.emit("getAndroidDeviceDetails", (response) => {
            if (response && response !== null) {
                resolve(response);
            } else {
                reject("Invalid MiniWidget data or response is empty");
            }
        });

    });
}

// Saga function for fetching Android Analytics data
function* fetchAndoridAnalyticsSaga() {
    try {
        const data = yield call(fetchAndoridAnalyticsDataApi);
        yield put(fetchAndroidAnalyticsSuccess(data));
    } catch (error) {
        console.error("Error fetching web insight data:", error);
        yield put(fetchAndroidAnalyticsFailure(error.toString()));
    }
}

// API call function for fetching Recent Active Devices
function fetchAndroidRecentApi(days) {
    return new Promise((resolve, reject) => {
        socket.emit("getLastOnlineDevices", { days }, (response) => {
            if (response !== undefined) {
                resolve(response);
            } else {
                reject("Invalid data");
            }
        });
    });
}

// Saga Worker for fetching Recent Active Devices
function* fetchAndroidRecentSaga(action) {
    try {
        const { days } = action.payload;
        const data = yield call(fetchAndroidRecentApi, days);
        yield put(fetchRecentActiveSuccess(data));
    } catch (error) {
        yield put(fetchRecentActiveFailure(error.toString()));
    }
}

// API call function for fetching new beta joiner
function fetchNewBetaJoinerApi(days) {
    console.log(days);
    return new Promise((resolve, reject) => {
        socket.emit("getLatestBetaSubscriber", { days }, (response) => {
            if (response !== undefined) {
                resolve(response);
            } else {
                reject("Invalid data");
            }
        });
    });
}

// Saga Worker for fetching new beta joiner
function* fetchNewBetaJoinerSaga(action) {
    try {
        const { days } = action.payload;
        const data = yield call(fetchNewBetaJoinerApi, days);
        yield put(fetchNewBetaJoinerSuccess(data));
    } catch (error) {
        yield put(fetchNewBetaJoinerFailure(error.toString()));
    }
}

// Watcher Sagas
export function* watchWebVisitorsSaga() {
    yield takeLatest(FETCH_WEB_VISITORS_REQUEST, fetchWebVisitorsSaga);
}

export function* watchDeviceCountsSaga() {
    yield takeLatest(FETCH_WEB_MINIWIDGET_REQUEST, fetchDeviceCountsSaga);
}

export function* watchBetaAnalyticsSaga() {
    yield takeLatest(FETCH_BETA_SALES_REQUEST, fetchBetaSubscriberSaga);
}

export function* watchApplicationInstallationSaga() {
    yield takeLatest(APPLICTION_INSTALATION_REQUEST, fetchApplicationINstaltionSaga);
}

export function* webWeeklyInsightSaga() {
    yield takeLatest(WEB_WEEKLY_INSIGHT_REQUEST, fetchWebInsightSaga);
}

export function* watchAndroidUsersAnalytics() {
    yield takeLatest(ANDROID_USER_ANALYTICS_REQUEST, fetchAndoridAnalyticsSaga);
}

export function* watchRecentActiveDevices() {
    yield takeLatest(ANDROID_RECENT_ACTIVE_REQUEST, fetchAndroidRecentSaga);
}

export function* watchNewBetaJoiner() {
    yield takeLatest(NEW_BETA_JOINER_REQUEST, fetchNewBetaJoinerSaga);
}